<entity-table class="d-flex flex-column h-100"
    tableTitle="Animals" 
    [facet]="facet"
    [entities]="cohort.CohortMaterial"
    [columns]="columns" 
    (remove)="onRemove($event)"
    (copy)="onCopy()"
    (columnSelectChange)="onColumnSelectChanged()">
</entity-table>
